<template>
  <div class="container unanimate">
    <div class="title animate-target" v-animate-in>
      Part 3
      <hr/>
    </div>
    <h1 class="animate-target" v-animate-in>{{$route.meta.sub_header}}</h1>

    <router-link to="/section3/3-1" class="btn btn_kerendia animate-target" v-animate-in>Continue</router-link>
  </div>
</template>

<script>
export default {
  name: "s3_index"
}
</script>

<style scoped>

</style>
